import * as React from 'react';

import { Helmet } from 'react-helmet-async';
import { useLoaderData } from 'react-router-dom';

import { PurchaseFormContext } from 'context';
import type { ComponentMode, Purchase as PurchaseConfig } from 'types';
import { fixedParseFloat } from 'utils';

import { PurchaseForm, PurchaseHeader } from './components';

type PurchaseProps = {
  mode: ComponentMode;
};

export default function Purchase({ mode }: PurchaseProps) {
  const data = useLoaderData() as PurchaseConfig | undefined;

  const { purchaseProducts = [], ...otherData } = data ?? {};
  const { trackingCode, status } = data ?? {};
  const isUpdatedMode = mode === 'Update';

  const step = 1;
  const title = isUpdatedMode ? `سفارش ${trackingCode}` : 'افزودن سفارش جدید';
  const defaultStatus: typeof status = isUpdatedMode ? status : 'Purchased';

  return (
    <React.Fragment>
      <Helmet>
        <title>{`${title} | کاشی لند`}</title>
      </Helmet>
      <PurchaseHeader>{title}</PurchaseHeader>
      <PurchaseFormContext
        mode={mode}
        step={step}
        defaultStatus={defaultStatus}
        purchaseProducts={purchaseProducts.map(purchaseProduct => {
          const { packagingInfo, size, price } = purchaseProduct;
          const defaultAmount = fixedParseFloat(size / packagingInfo.amount, 3);

          return {
            ...purchaseProduct,
            updatedPrice: price,
            amount: defaultAmount,
            maxAmount: defaultAmount,
          };
        })}
        {...(isUpdatedMode ? otherData : {})}
      >
        <PurchaseForm />
      </PurchaseFormContext>
    </React.Fragment>
  );
}
